import { CountryData } from '@smiles/core-utils/dist/Types/Countries.types';
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getListCountry } from 'services/core/services';

interface ConstantsProps {
  countriesList: CountryData[];
}

const ConstantsContext = createContext<ConstantsProps>({
  countriesList: [],
});

export const useConstants = () => useContext(ConstantsContext);

export const ConstantProvider: React.FC = ({ children }) => {
  const [countriesList, setCountriesList] = useState<CountryData[]>([]);

  const initializeCountries = useCallback(async () => {
    const response = await getListCountry();

    const countries = response.data as CountryData[];

    setCountriesList(countries);
  }, []);

  useEffect(() => {
    initializeCountries();
  }, []);

  return <ConstantsContext.Provider value={{ countriesList }}>{children}</ConstantsContext.Provider>;
};
